"use client";

import { ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";

const RADIUS = 22;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function ScrollToTopButton() {
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

            setShowScrollTop(scrollY > 150);
            setScrollProgress(maxScroll > 0 ? Math.min(scrollY / maxScroll, 1) : 0);
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
            <button
                type="button"
                onClick={scrollToTop}
                aria-label="Retourner en haut de la page"
                aria-hidden={!showScrollTop}
                tabIndex={showScrollTop ? 0 : -1}
                className={`fixed bottom-20 right-6 z-30 inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg transition-all duration-300 ease-out hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 ${
                    showScrollTop
                        ? "translate-y-0 scale-100 opacity-100"
                        : "pointer-events-none invisible translate-y-3 scale-75 opacity-0"
                }`}
            >
                <svg
                    className="pointer-events-none absolute inset-0 h-full w-full -rotate-90"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                >
                    <circle
                        cx="24"
                        cy="24"
                        r={RADIUS}
                        fill="none"
                        stroke="currentColor"
                        strokeOpacity="0.25"
                        strokeWidth="3"
                    />
                    <circle
                        cx="24"
                        cy="24"
                        r={RADIUS}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeDasharray={CIRCUMFERENCE}
                        strokeDashoffset={CIRCUMFERENCE * (1 - scrollProgress)}
                        className="transition-[stroke-dashoffset] duration-150 ease-out"
                    />
                </svg>
                <ChevronUp className="h-5 w-5" />
            </button>
    );
}
